import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Output,
} from '@angular/core';
import { ButtonColor, ButtonSize } from '@freelancer/ui/button';
import { HeadingType } from '@freelancer/ui/heading';
import { TextSize } from '@freelancer/ui/text';
import { ConfirmationModalResponse } from './quotation-action-confirmation-modal-content.types';

@Component({
  selector: 'app-quotation-action-confirmation-modal-content',
  template: `
    <div class="ConfirmationModal">
      <fl-heading
        [flMarginBottom]="'small'"
        [headingType]="HeadingType.H2"
        [size]="TextSize.MID"
      >
        <ng-content select="heading"></ng-content>
      </fl-heading>
      <div [flMarginBottom]="'mid'">
        <ng-content select="body"></ng-content>
      </div>
      <div
        class="ConfirmationModal-actionContainer"
        flTrackingSection="QuotationConfirmationModal"
      >
        <fl-button
          flTrackingLabel="QuotationConfirmationModalCancelButton"
          i18n="Quotation Action Confirmation Modal Cancel Button"
          [flMarginRight]="'small'"
          [color]="ButtonColor.TRANSPARENT_DARK"
          [size]="ButtonSize.SMALL"
          [sizeTablet]="ButtonSize.LARGE"
          [sizeDesktop]="ButtonSize.SMALL"
          [busy]="pendingAction == ConfirmationModalResponse.CANCEL"
          [disabled]="pendingAction !== undefined"
          (click)="onCancel()"
        >
          Close
        </fl-button>
        <fl-button
          flTrackingLabel="QuotationConfirmationModalConfirmButton"
          i18n="Quotation Action Confirmation Modal Confirm Button"
          [color]="ButtonColor.SECONDARY"
          [size]="ButtonSize.SMALL"
          [sizeTablet]="ButtonSize.LARGE"
          [sizeDesktop]="ButtonSize.SMALL"
          [busy]="pendingAction == ConfirmationModalResponse.CONFIRM"
          [disabled]="pendingAction !== undefined"
          (click)="onConfirm()"
        >
          Confirm
        </fl-button>
      </div>
    </div>
  `,
  styleUrls: ['./quotation-action-confirmation-modal-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QuotationActionConfirmationModalContentComponent {
  HeadingType = HeadingType;
  TextSize = TextSize;
  ButtonColor = ButtonColor;
  ButtonSize = ButtonSize;
  ConfirmationModalResponse = ConfirmationModalResponse;
  pendingAction?: ConfirmationModalResponse;

  @Output() response = new EventEmitter<ConfirmationModalResponse>();

  onCancel(): void {
    this.onResponse(ConfirmationModalResponse.CANCEL);
  }

  onConfirm(): void {
    this.onResponse(ConfirmationModalResponse.CONFIRM);
  }

  onResponse(response: ConfirmationModalResponse): void {
    // put the buttons into a busy/disabled state, if another response is needed, the flow should prompt the user afresh.
    this.pendingAction = response;
    this.response.emit(response);
  }
}
